/* unplugin-vue-components disabled */import script from "./DiscountPlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiscountPlan.vue?vue&type=script&setup=true&lang=ts"

import "./DiscountPlan.vue?vue&type=style&index=0&id=e7b74c9c&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7b74c9c"]])

export default __exports__